import { call, put, takeLatest } from 'redux-saga/effects';
import { IAction, IUser } from '../../types';
import ProfileActionConstants from '../../constants/actions/ProfileActionConstants';
import SagaHelpers from '../../common/helpers/SagaHelpers';
import ProfileService from '../../services/common/ProfileService';
import { RequestServiceResponse } from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import ProfileActions from '../../actions/ProfileActions';

export interface IGetProfileAction extends IAction {
    type: typeof ProfileActionConstants.GET_PROFILE;
    payload: { userId: number };
}

export function* getProfile(action: IGetProfileAction) {
    try {
        const response = (yield call(
            ProfileService.getProfile,
            action.payload,
        )) as RequestServiceResponse<IUser>;

        yield put(ProfileActions.getProfileSuccess(response.data));
    } catch (ex) {
        const error = ex.response?.statusText || ex.message;
        yield put(ProfileActions.getProfileFail(error));

        yield put(NotificationActions.error(error));
    }
}

export function* saveProfile(action: IGetProfileAction) {
    yield SagaHelpers.handleRequest({
        request: [ProfileService.saveProfile, action.payload],
        actions: [
            (payload) => ({
                type: ProfileActionConstants.SAVE_PROFILE_SUCCESS,
                payload,
            }),
            (error) => ({
                type: ProfileActionConstants.SAVE_PROFILE_FAIL,
                error,
            }),
        ],
    });
}

export default [
    takeLatest(ProfileActionConstants.GET_PROFILE, getProfile),
    takeLatest(ProfileActionConstants.SAVE_PROFILE, saveProfile),
];
